import React from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { NitroMarkerBase } from "../../../../components/map/components/NitroMarker";
import TruckIconFO from "../../../../icons/TruckIconFO";
import RailIconFO from "../../../../icons/RailIconFO";
import { DestinationQuoteWithSummary } from "../../../../types/IMultiLocationQuoteMobile";

interface LocationQuoteCardProps {
  item: DestinationQuoteWithSummary;
  onSelect: (item: DestinationQuoteWithSummary) => void;
  onLocationNameClick?: (item: DestinationQuoteWithSummary) => void;
}

const LocationQuoteCard: React.FC<LocationQuoteCardProps> = ({
  item,
  onSelect,
  onLocationNameClick,
}) => {
  return (
    <div
      key={`${item.destination.name}-${item.destination.city || ""}`}
      className="location-card"
      role="button"
      tabIndex={0}
      onClick={() => onSelect(item)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") onSelect(item);
      }}
    >
      <div className="card-top-row">
        <span id="quote-card-destination-marker">
          <NitroMarkerBase
            width={24}
            height={40}
            type={(item.destination as any).pinType || ""}
          />
        </span>

        <div className="card-middle-column">
          <div
            id="quote-panel-location-name"
            className="location-name"
            onClick={(e) => {
              e.stopPropagation();
              if (onLocationNameClick) {
                onLocationNameClick(item);
                return;
              }
              onSelect(item);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.stopPropagation();
                if (onLocationNameClick) {
                  onLocationNameClick(item);
                  return;
                }
                onSelect(item);
              }
            }}
            role="button"
            tabIndex={0}
          >
            {item.destination.name}
          </div>
          <div id="quote-panel-metrics-row" className="card-metrics-row">
            <div className="metric-col">
              <span className="metric-label">DLVD Offer</span>
              <span className="dlvd-offer-metric-value">
                ${item.summary.deliveredPrice}
              </span>
            </div>

            <div className="metric-col center">
              {item.summary.mode?.toUpperCase() === "TRUCK" && (
                <TruckIconFO color="#60A5FA" paddingTop={4} />
              )}
              {item.summary.mode?.toUpperCase() === "RAIL" && (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "4px" }}
                >
                  <RailIconFO color="#F97316" />
                  <span id="rail-min-cars" className="metric-value-sm">
                    {item.summary.mode?.toUpperCase() === "RAIL" &&
                      (item.summary.freight &&
                      "minCars" in item.summary &&
                      typeof item.summary.minCars === "number" &&
                      item.summary.minCars > 1 ? (
                        <>({item.summary.minCars}+)</>
                      ) : (
                        "1+"
                      ))}
                  </span>
                </div>
              )}
              <span className="freight-value-quote">
                ${item.summary.freight}
              </span>
            </div>

            <div id="quote-panel-origin-name" className="metric-col right">
              <span className="origin-link">{item.summary.originName}</span>
              <span className="dlvd-offer-metric-value">
                ${item.summary.netback}
              </span>
            </div>
          </div>
        </div>
        <ChevronRightIcon className="chevron-icon" />
      </div>
    </div>
  );
};

export default LocationQuoteCard;
